module.exports = __webpack_public_path__ + "static/media/circle-green.738fceaa.svg";